<div class="edit-lifecycle-points-modal" *transloco="let t; prefix: 'assetOverview.lifecycleModal'">

  <div class="edit-lifecycle-points-modal__header">
    <span>{{ t('title') }}</span>
    <button class="edit-lifecycle-points-modal__close" (click)="onCancel()">
      <i class="ph ph-x"></i>
    </button>
  </div>

  <div class="edit-lifecycle-points-modal__body">
    <div class="section-label">{{ t('registrationDetails') }}</div>

    <div class="form-field">
      <label class="field-label" for="assetName">{{ t('assetName') }} <span class="required-indicator">*</span></label>
      <input
        id="assetName"
        type="text"
        class="form-control"
        maxlength="255"
        [value]="assetName ?? ''"
        (input)="onAssetNameInput($event)" />
    </div>

    <div class="points-row">
      <div class="form-field">
        <label class="field-label" for="licensePlate">{{ t('licensePlate') }}</label>
        <input
          id="licensePlate"
          type="text"
          class="form-control"
          maxlength="50"
          [value]="licensePlate ?? ''"
          (input)="onLicensePlateInput($event)" />
      </div>

      <div class="form-field">
        <label class="field-label">{{ t('mainColour') }}</label>
        <div class="form-control colour-readonly">
          @if (mainColour) {
            <span class="colour-readonly-swatch" [style.background]="mainColourHex || '#FFFFFF'"></span>
            <span>{{ mainColour }}</span>
          } @else {
            <span>{{ t('none') }}</span>
          }
        </div>
      </div>
    </div>

    <div class="section-divider"></div>

    <div class="section-label">{{ t('lifecycleData') }}</div>

    <div class="points-row">
      <div class="form-field">
        <label class="field-label" for="sellingPointKm">{{ t('sellingPoint') }}</label>
        <div ngbDropdown class="custom-dropdown" [autoClose]="true">
          <div class="dropdown-input-wrapper">
            <input
              id="sellingPointKm"
              type="number"
              min="1"
              class="form-control dropdown-toggle"
              [class.has-suffix]="sellingPointKm != null"
              ngbDropdownToggle
              [placeholder]="t('enterOrSelect')"
              [value]="sellingPointKm ?? ''"
              (input)="onSellingPointInput($event)" />
            @if (sellingPointKm != null) {
              <span class="input-suffix">{{ t('kmSuffix') }}</span>
            }
            <i class="ph ph-caret-down lh-base"></i>
          </div>

          <div ngbDropdownMenu>
            <div class="d-flex flex-column">
              @for (option of kmOptions; track option.value) {
                <button type="button" class="btn btn-outline" ngbDropdownItem (click)="selectSellingPoint(option.value, $event)">
                  {{ option.label }}
                </button>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="form-field">
        <label class="field-label" for="retirePointKm">{{ t('retirementPoint') }}</label>
        <div ngbDropdown class="custom-dropdown" [autoClose]="true">
          <div class="dropdown-input-wrapper">
            <input
              id="retirePointKm"
              type="number"
              min="1"
              class="form-control dropdown-toggle"
              [class.has-suffix]="retirePointKm != null"
              ngbDropdownToggle
              [placeholder]="t('enterOrSelect')"
              [value]="retirePointKm ?? ''"
              (input)="onRetirePointInput($event)" />
            @if (retirePointKm != null) {
              <span class="input-suffix">{{ t('kmSuffix') }}</span>
            }
            <i class="ph ph-caret-down lh-base"></i>
          </div>

          <div ngbDropdownMenu>
            <div class="d-flex flex-column">
              @for (option of kmOptions; track option.value) {
                <button type="button" class="btn btn-outline" ngbDropdownItem (click)="selectRetirePoint(option.value, $event)">
                  {{ option.label }}
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    @if (validationMessage) {
      <div class="validation-message">{{ validationMessage }}</div>
    }
  </div>

  <div class="edit-lifecycle-points-modal__footer">
    <button class="btn-cancel" (click)="onCancel()" [disabled]="isSaving">{{ 'common.cancel' | transloco }}</button>
    <button class="btn-save" (click)="onSave()" [disabled]="isSaving || !canSave">
      @if(isSaving) {
        <span class="spinner-border spinner-border-sm me-1"></span>
      }
      {{ t('save') }}
    </button>
  </div>

</div>
